// --- START OF FILE BotonCompartir.js ---
import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import ShareModal from './modals/ShareModal'; 
import '../styles/BotonCompartir.css'; 

const BotonCompartir = ({ userProfile }) => { // Recibe el perfil del usuario como prop.
    const [isModalOpen, setIsModalOpen] = useState(false);

    // El componente padre ahora es responsable de pasar un perfil válido.
    // Si no hay perfil o nombre de usuario, el botón se mostrará deshabilitado.
    const canShare = userProfile && userProfile.username;

    // CORRECCIÓN DEFINITIVA: El enlace de referido debe apuntar a la ruta /register para forzar la vista de registro.
    const referralLink = canShare ? `${window.location.origin}/register?ref=${encodeURIComponent(userProfile.username)}` : '';

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)} 
                className="share-button"
                disabled={!canShare}
                title={!canShare ? "Completa tu perfil para obtener tu enlace de referido" : "Invita a tus amigos"}
            >
                <Share2 size={18} />
                Invita a tus amigos
            </button>
            {isModalOpen && (
                <ShareModal 
                    link={referralLink}
                    userProfile={userProfile}
                    onClose={() => setIsModalOpen(false)} 
                />
            )}
        </>
    );
};

export default BotonCompartir;
